import types from '../types';
import getCountryChildrenAges from '../../../utility/getCountryChildrenAges';

function getAges({ fromCode, toCode }) {
  return {
    type: types.GET_AGES,
    ages: getCountryChildrenAges(fromCode, toCode),
  };
}

export default getAges;
